import {
  Button,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  useTheme,
} from '@chakra-ui/react';
import BackButton from '@components/BackButton';
import IncludeButton from '@components/IncludeButton';
import { IncludeButtonProps } from '@components/IncludeButton/interfaces';
import React from 'react';
import { MdInfoOutline } from 'react-icons/md';

import { useScreenshotContext } from '@/screens/Dashboard/contexts/ScreenshotContext';

import { SimpleHeaderRenderProps } from './interfaces';
import {
  ButtonsContainer,
  Container,
  ImageContainer,
  LeftContainer,
  RightContainer,
  Title,
} from './styles';

const renderButton = (button: IncludeButtonProps) => (
  <IncludeButton
    key={button.key || button.title}
    callback={button.callback}
    title={button.title}
    style={button.style || {}}
    className={button.className || ''}
  />
);

const Header: React.FC<SimpleHeaderRenderProps> = ({
  title,
  pictureLogo,
  isMobile,
  buttons,
  dashInfo,
}) => {
  const theme = useTheme();
  const { isCapturingScreenshot } = useScreenshotContext();

  return (
    <Container havePictureLogo={!!pictureLogo}>
      <LeftContainer>
        {pictureLogo ? (
          <ImageContainer maxHeight="80px" padding="2px" borderRadius="12px">
            <img
              style={{ height: '100%', borderRadius: '12px' }}
              src={pictureLogo}
              alt="pictureLogo"
            />
          </ImageContainer>
        ) : (
          <Flex alignItems="center">
            <Title>{title}</Title>
            {dashInfo && (
              <Popover placement="bottom-start">
                <PopoverTrigger>
                  <Button variant="unstyled">
                    <MdInfoOutline size={24} color={theme.colors.gray[500]} />
                  </Button>
                </PopoverTrigger>
                <PopoverContent>
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverHeader>{dashInfo?.title}</PopoverHeader>
                  <PopoverBody>
                    {dashInfo?.content?.map((item) => (
                      <p key={item}>{item}</p>
                    ))}
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            )}
          </Flex>
        )}
      </LeftContainer>

      {!isMobile && !isCapturingScreenshot && (
        <RightContainer>
          {buttons ? (
            <ButtonsContainer>
              {buttons.map((button) =>
                button?.Component ? (
                  <button.Component {...button?.props} />
                ) : (
                  renderButton(button)
                ),
              )}
            </ButtonsContainer>
          ) : (
            <BackButton />
          )}
        </RightContainer>
      )}
    </Container>
  );
};

export default Header;
